import React from 'react';

function Header(){
  return(
    <header className="header">
      <div className="logo"></div>
    </header>
  )
}

export default Header;